import { Text } from '@ekhodealer/ekho-common/rev';

interface EstFulfillmentDateCellProps {
	estFulfillmentDate?: string;
}

export const EstFulfillmentDateCell = ({ estFulfillmentDate }: EstFulfillmentDateCellProps) => {
	const displayText = estFulfillmentDate || '—';

	return (
		<div style={{ minWidth: '160px' }}>
			<Text size='bodySmall'>{displayText}</Text>
		</div>
	);
};
